<template>
  <div>
    <!--    title-->
    <v-row
      style="border-bottom: 1px solid #E5E7EB;"
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start block-title"
      >
        <div
          class="block-title--wrapper"
        >
          {{ $t('fleet/activity.vehicle_comments') }}
        </div>
      </v-col>

      <v-col
        class="d-flex justify-end"
      >
        <table-row-actions-menu
          :data-index="itemIndex"
          :config="actionsConfig"
          :table-data="data"
        />
      </v-col>
    </v-row>

    <!--    visible data section-->
    <v-row
      v-for="(dataObject, dataObjIndex) in getVisibleItemDetails()"
      :key="dataObjIndex"
      class="margin-0"
    >
      <v-col
        class="data-label"
      >
        {{ dataObject.label }}
      </v-col>

      <v-col
        class="d-flex justify-end data-value"
      >
        <template
          v-if="dataObject.key === 'images'"
        >
          <table-image-icon-with-counter
            :cell-data="dataObject.value"
            :config="dataObject"
            :row-data="item"
          />
        </template>
        <template
          v-else
        >
          {{ dataObject.value }}
        </template>
      </v-col>
    </v-row>

    <information-dialog
      :open-dialog="informationDialogConfig.openDialog"
      :title="informationDialogConfig.title"
      :dialog-message="informationDialogConfig.message"
      :positive-button-text="informationDialogConfig.positiveBtnText"
      :negative-button-text="informationDialogConfig.negativeBtnText"
      :confirm-callback-function="informationDialogConfig.callbackFn"
      @close="$set(informationDialogConfig, 'openDialog', false)"
    />

    <images-preview-dialog
      v-if="imagesPreviewDialogConfig.show"
      :show-dialog="imagesPreviewDialogConfig.show"
      :dialog-title="imagesPreviewDialogConfig.title"
      :images="imagesPreviewDialogConfig.images"
      :field="imagesPreviewDialogConfig.field"
      :remove-callback="imagesPreviewDialogConfig.removeCallback"
      :remove-api-config="imagesPreviewDialogConfig.removeApiConfig"
      @close="imagesPreviewDialogConfig.show = false"
    />
  </div>
</template>

<script>
import TableRowActionsMenu from '@/global/components/table/components/TableRowActionsMenu.vue'
import InformationDialog from '@/global/components/dialogs/InformationDialog.vue'
import { dateService, FORMATS } from '@/global/services/date'
import TableImageIconWithCounter from '../../components/TableImageIconWithCounter.vue'
import previewFiles from '../../helpers/previewFiles'
import ImagesPreviewDialog from '@/global/components/dialogs/ImagesPreviewDialog.vue'
import vehicleCommentMixin from '../../mixins/vehicleCommentMixin'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

const DEFAULT_EMPTY_VALUE = '--'
export default {
  name: 'VehicleCommentGridBlock',

  components: {
    ImagesPreviewDialog,
    TableImageIconWithCounter,
    InformationDialog,
    TableRowActionsMenu
  },

  mixins: [
    previewFiles,
    vehicleCommentMixin
  ],

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    blockConfig: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      slidedDown: false,
      informationDialogConfig: {
        openDialog: false,
        message: this.$t('fleet/vehicle.confirm_delete'),
        title: '',
        positiveBtnText: '',
        negativeBtnText: this.$t('base.cancel'),
        callbackFn: () => {}
      },
      documentEmailId: null,
      documentEmailFormData: {},
      documentEmailValidationErrors: {},
      documentValidationErrors: {},
      dateFormat: FORMATS.date,
      imagesPreviewDialogConfig: {
        show: false,
        title: this.$t('fleet/vehicle_comment.images'),
        field: {},
        images: [],
        removeApiConfig: {
          module: 'fleet',
          route: ''
        },
        removeCallback: (event) => this.commentRemoveImageCallback(event)
      }
    }
  },

  computed: {
    actionsConfig () {
      return {
        tableConfig: {
          actionsConfig: [
            showDetailsAction(this.$t, (event) => this.onShowCommentDetails(event)),
            deleteAction(this.$t, (event) => this.onCommentDelete(event))
          ]
        }
      }
    }
  },

  methods: {
    getVisibleItemDetails () {
      return [
        {
          label: this.$t('fleet/vehicle_range_limit.input_date'),
          value: this.item?.created_at ? dateService.formatFromUtc(this.item.created_at, FORMATS.datetimeShort) : DEFAULT_EMPTY_VALUE
        },
        {
          label: this.$t('fleet/vehicle_comment.text'),
          value: this.item?.body || DEFAULT_EMPTY_VALUE
        },
        {
          label: this.$t('fleet/vehicle_comment.wrote_by'),
          value: this.item?.user || DEFAULT_EMPTY_VALUE
        },
        {
          key: 'images',
          label: this.$t('fleet/vehicle_comment.images'),
          value: this.item?.images || [],
          onClick: (event) => this.showImages(event, {
            module: 'fleet',
            route: 'vehicle-comment/remove-image/'
          }, 'comments')
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.block-title {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.block-title--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}

.arrowUpDown {
  position: absolute;
  bottom: 10px;
  left: 50%;
}

.arrowUpDown:hover {
  cursor: pointer;
}
</style>
